import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Menu from './views/Menu.vue'
import TermsAgreement from './views/TermsAgreement.vue'
import Wards from './views/Wards.vue'
import Towns from './views/Towns.vue'
import Address from './views/Address.vue'
import MapPane from './views/MapPane.vue'
import BrowseGaiyo from './views/BrowseGaiyo.vue'
import BrowseBuild from './components/BrowseBuild.vue'
import BrowseElevator from './views/BrowseElevator'
import BrowseDaicho from './views/BrowseDaicho.vue'
import Loading from './views/Loading.vue'
import ListResult from './views/ListResult.vue'
import ListAttr from './views/ListAttr.vue'
import ListExamDisp from './views/ListExamDisp.vue'
import ListEst from './views/ListEst.vue'
import ListPrint from './views/ListPrint.vue'
import Print from './views/Print.vue'
import PrintImage from './views/PrintImage.vue'
import PrintImageA4 from './views/PrintImageA4.vue'
import PrintKosaku from './views/PrintKosaku.vue'
import MenuSearchMethod from './views/MenuSearchMethod'
import SearchNo from './views/SearchNo'
import SearchShiteiNo from './views/SearchShiteiNo'
import SearchAttr from './views/SearchAttr'
import SelectPlotIndex from './views/SelectPlotIndex'
import PlotIndex from './views/PlotIndex'
import PlotMap from './views/PlotMap'
import BrowseKaihatsu from './views/BrowseKaihatsu'
import BrowseSpRoad from './views/BrowseSpRoad'
import BrowseKyoai from './views/BrowseKyoai'
import BrowseKosaku from './views/BrowseKosaku'

// 2023/10/17
import KamiNormalModeSearch from './views/KamiNormalModeSearch'
import KamiViewingModeSearch from './views/KamiViewingModeSearch'
import KamiSearchResult from './views/KamiSearchResult'
import KamiSearchResultBrief from './views/KamiSearchResultBrief'
import KamiInformationInput from './views/KamiInformationInput'
import KamiCertificate from './views/KamiCertificate'
import KousakuWards from './views/KousakuWards'
import KousakuTown from './views/KousakuTown'
import KousakuAddress from './views/KousakuAddress'
import KousakuListResult from './views/KousakuListResult'
import KousakuLoading from './views/KousakuLoading'
import KousakuInformation from './views/KousakuInformation'
// 2023/12/10
//import KamiSearchResultprint from './views/KamiSearchResultprint'
import KamiSearchResultprint from './views/BrowseDaichoEdited'
import KamiDispImage from './views/KamiDispImage'

// 2024/07/09 電子申請書
import BrowseDaichoKakuShin from './views/BrowseDaichoKakuShin.vue'

import { dbglog } from './common/utils.js'

Vue.use(Router)

const TERMS_ROUTE_NAME = 'terms-agreement'
const TERMS_AGREED_KEY = 'madogiwa-terms-agreed'

const router = new Router({
  base: '/ges/',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/terms-agreement',
      name: TERMS_ROUTE_NAME,
      component: TermsAgreement,
    },
    {
      path: '/menu',
      name: 'menu',
      component: Menu
    },
    {
      path: '/wards',
      name: 'wards',
      component: Wards,
      props: true,
    },
    {
      path: '/towns',
      name: 'towns',
      component: Towns,
      props: true,
    },
    {
      path: '/address',
      name: 'address',
      component: Address
    },
    {
      path: '/map',
      name: 'map',
      component: MapPane,
      props: true,
    },
    {
      path: '/listresult',
      name: 'list-result',
      component: ListResult,
      props: true,
    },
    {
      path: '/listattr',
      name: 'list-attr',
      component: ListAttr,
      props: true,
    },
    {
      path: '/listexamdisp',
      name: 'list-exam-disp',
      component: ListExamDisp,
      props: true,
    },
    {
      path: '/listest',
      name: 'listest',
      component: ListEst,
      props: true,
    },
    {
      path: '/browsegaiyo',
      name: 'browsegaiyo',
      component: BrowseGaiyo,
      props: true,
    },
    {
      path: '/browsebuild',
      name: 'browse-build',
      component: BrowseBuild,
      props: true,
    },
    {
      path: '/browseelv',
      name: 'browseelv',
      component: BrowseElevator
    },
    {
      path: '/browsedaicho',
      name: 'browsedaicho',
      component: BrowseDaicho
    },
    {
      path: '/loading',
      name: 'loading',
      component: Loading,
      props: true,
    },
    {
      path: '/listprint',
      name: 'listprint',
      component: ListPrint,
    },
    {
      path: '/print',
      name: 'print',
      component: Print,
    },
    {
      path: '/printimage',
      name: 'print-image',
      component: PrintImage,
      props: true,
    },
    {
      path: '/printimageA4',
      name: 'print-image-A4',
      component: PrintImageA4,
      props: true,
    },
    {
      path: '/printkosaku',
      name: 'print-kosaku',
      component: PrintKosaku,
      props: true,
    },
    {
      path: '/method',
      name: 'method',
      component: MenuSearchMethod,
    },
    {
      path: '/searchno',
      name: 'search-no',
      component: SearchNo,
    },
    {
      path: '/searchshiteino',
      name: 'search-shiteino',
      component: SearchShiteiNo,
    },
    {
      path: '/searchattr',
      name: 'search-attr',
      component: SearchAttr,
    },
    {
      path: '/selectplotindex',
      name: 'select-plotindex',
      component: SelectPlotIndex,
      props: true,
    },
    {
      path: '/plotindex',
      name: 'plot-index',
      component: PlotIndex,
      props: true,
    },
    {
      path: '/plotmap',
      name: 'plot-map',
      component: PlotMap,
      props: true,
    },
    {
      path: '/browsekaihatsu',
      name: 'browse-kaihatsu',
      component: BrowseKaihatsu,
      props: true,
    },
    {
      path: '/browsesproad',
      name: 'browse-sproad',
      component: BrowseSpRoad,
      props: true,
    },
    {
      path: '/browsekyoai',
      name: 'browse-kyoai',
      component: BrowseKyoai,
      props: true,
    },
    {
      path: '/browsekosaku',
      name: 'browse-kosaku',
      component: BrowseKosaku,
    },
    // 2023/10/17
    {
      path: '/kamisearchattr',
      name: 'kamisearchattr',
      component: KamiNormalModeSearch,
      props: true,
    },
    {
      path: '/kamivsearchattr',
      name: 'kamivsearchattr',
      component: KamiViewingModeSearch,
      props: true,
    },
    {
      path: '/kamiresult',
      name: 'kamiresult',
      component: KamiSearchResult,
      props: true,
    },
    {
      path: '/kamiresultbrief',
      name: 'kamiresultbrief',
      component: KamiSearchResultBrief,
      props: true,
    },
    {
      path: '/kamiresultinput',
      name: 'kamiresultinput',
      component: KamiInformationInput,
    },
    {
      path: '/kamicertificate',
      name: 'kami-certificate',
      component: KamiCertificate,
    },
    {
      path: '/kamisearchresultprint',
      name: 'kamisearchresultprint',
      component: KamiSearchResultprint,
    },
    {
      path: '/kamidispimage',
      name: 'Kamidispimage',
      component: KamiDispImage,
      props: (route) => ({ image: route.query.image }) 
    },
    {
      path: '/kousakuwards',
      name: 'kousakuwards',
      component: KousakuWards,
      props: true,
    },
    {
      path: '/kousakutown',
      name: 'kousakutown',
      component: KousakuTown,
      props: true,
    },
    {
      path: '/kousakuaddress',
      name: 'kousakuaddress',
      component: KousakuAddress,
    },
    {
      path: '/kousakulistresult',
      name: 'kousakulistresult',
      component: KousakuListResult,
      props: true,
    },
    {
      path: '/kousakuloading',
      name: 'kousakuloading',
      component: KousakuLoading,
      props: true,
    },
    {
      path: '/kousakuinformation',
      name: 'kousaku-information',
      component: KousakuInformation,
    },
    {
      path: '/BrowseDaichoKakuShin',
      name: 'BrowseDaichoKakuShin',
      component: BrowseDaichoKakuShin,
      props: true,
    },
  ],
  scrollBehavior (to, from, savePosition) {
    dbglog(from);
    dbglog(savePosition);
    return to.hash ?
      { selector: to.hash, offset: { x: 0, y: 64 } } :
      { x: 0, y: 0 }
  }
})

/**
 * 窓際端末(authority=5)で利用規約未同意のまま保護対象画面へ進もうとした場合、
 * 利用規約画面へリダイレクトする。
 */
router.beforeEach((to, from, next) => {
  const authority = Number(sessionStorage.getItem('madogiwa-authority') || 0);
  const hasAgreed = sessionStorage.getItem(TERMS_AGREED_KEY) === 'true';
  const auth5NeedsTerms = authority === 5 && to.name !== 'login' && to.name !== TERMS_ROUTE_NAME;

  if (auth5NeedsTerms && !hasAgreed) {
    next({ name: TERMS_ROUTE_NAME });
    return;
  }

  next();
});

export default router
